/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
/** Boundary of a one-dimensional interval. */
export var Boundary = {
    START: "start",
    // tslint:disable-next-line:object-literal-sort-keys
    END: "end",
};
//# sourceMappingURL=boundary.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blueprintjs/core/lib/esm/common/boundary.js
// module id = 185
// module chunks = 0